module.exports = __webpack_public_path__ + "media/images/report_areas/daniellesig-f4495771ed2bf91b84c1e77db976b3c3.png";